import counterpart from 'counterpart';
import { VITE_TRANSACTION_DATE_KEY, VITE_ATTACH_CASE_KEY, VITE_AUTH_DATE_KEY, VITE_DETAIL_DRAWER_KEY, VITE_MERCHANT_NUMBER_KEY } from 'Constants/appEnvConstants';

export function getColumnListForSearch(id) {
  return [
    {
      id: 1,
      searchName: 'transaction',
      pageId: 'transaction_search',
      name: 'Transaction Search Results',
      headerName: 'Transaction Search',
      detailViewTitle: 'Transaction Details',
      returnToText: 'Return',
      canManageColumns: true,
      minMandateField: true,
      exportSearchInputName: "transactionSearchInput",
      exportType: "Transaction",
      dataColumns: [

      ],
      actions: [{
        title: 'Open Transaction Details',
        key: VITE_DETAIL_DRAWER_KEY,
        url: 'detail',
        style: {
          paddingLeft: 0,
          width: 200,
        },
      },
      {
        title: 'Attach Transaction To Case',
        key: VITE_ATTACH_CASE_KEY,
        url: 'detail',
        style: {
          paddingLeft: 15,
          display: 'none',
        },
      },
      ],
      defaultSort: [{
        key: VITE_TRANSACTION_DATE_KEY,
        order: 0,
      }],
      pageSize: 25,
      dateFormat: 'YYYY-MM-DD',
      isExportable: true,
      paginationRequired: false,
    },
    {
      id: 2,
      searchName: 'authorization',
      pageId: 'authorization_search',
      name: 'Authorization Search Results',
      headerName: 'Authorization Search',
      detailViewTitle: 'Authorization Details',
      returnToText: 'Return',
      titleRequired: false,
      minMandateField: true,
      exportSearchInputName: "authorizationSearchInput",
      exportType: "Authorization",
      dataColumns: [

      ],
      actions: [{
        title: 'Open Authorization Details',
        key: VITE_DETAIL_DRAWER_KEY,
        url: 'detail',
        style: {
          paddingLeft: 0,
          width: 200,
        },
      }],
      defaultSort: [{
        key: VITE_AUTH_DATE_KEY,
        order: 0,
      }],
      pageSize: 25,
      dateFormat: 'YYYY-MM-DD',
      isExportable: true,
      canManageColumns: true,
      paginationRequired: false,
    },
    {
      id: 3,
      searchName: 'merchant',
      pageId: 'merchant_search',
      name: 'Merchant Search Results',
      headerName: 'Merchant Search',
      detailViewTitle: 'Merchant Details',
      returnToText: 'Return',
      titleRequired: false,
      minMandateField: false,
      exportSearchInputName: "merchantSearchInput",
      exportType:"Merchant",
      dataColumns: [
      ],

      actions: [{
        title: 'Open Merchant Details',
        key: VITE_DETAIL_DRAWER_KEY,
        url: 'detail',
        style: {
          paddingLeft: 0,
          width: 200,
        },
      }],
      defaultSort: [{
        key: VITE_MERCHANT_NUMBER_KEY,
        order: 0,
      }],
      pageSize: 25,
      dateFormat: 'YYYY-MM-DD',
      isExportable: true,
      canManageColumns: true,
      paginationRequired: false,
    },
    {
      id: "4",
      searchName: 'relatedTransaction',
      pageId: 'related_transactions',
      name: 'Transaction Search Results',
      headerName: 'Transaction Search',
      detailViewTitle: 'Transaction Details',
      returnToText: 'Return',
      canManageColumns: true,
      minMandateField: true,
      exportSearchInputName: "relatedTransactionsInput",
      exportType: "RelatedTransactions",
      dataColumns: [

      ],
      actions: [{
        title: 'Open Transaction Details',
        key: VITE_DETAIL_DRAWER_KEY,
        url: 'detail',
        style: {
          paddingLeft: 0,
          width: 200,
        },
      },
      {
        title: 'Attach Transaction To Case',
        key: VITE_ATTACH_CASE_KEY,
        url: 'detail',
        style: {
          paddingLeft: 15,
          display: 'none',
        },
      },
      ],
      defaultSort: [{
        key: VITE_TRANSACTION_DATE_KEY,
        order: 0,
      }],
      pageSize: 25,
      dateFormat: 'YYYY-MM-DD',
      isExportable: true,
      paginationRequired: false,
    },
  ];
}

export function getFilterValues() {
  // Check if the selected acquirer is GPE (EU portal)
  const isGPEAcquirer = sessionStorage.getItem('appPortal') === 'GPE';
  
  let filterValues =[
    {id: 1, text: "GPN", value: "GPN"},
    {id: 2, text: "HPY", value: "HPY"},
    {id: 3, text: "EVO", value: "EVO"},
    ...(isGPEAcquirer ? [{id: 4, text: "GPE", value: "GPE"}] : [])
  ];
  return {
    data: [
      {
        filterTypeId: 1,
        filterTypeName: 'Transaction',
        apiUrl: 'api/v1/referencedata/transactions',
        filterElements: [
          {
            elementCategoryName: 'EXACT',
            elementId: 'acqRefNumber',
            elementLabel: 'Acquirer Reference Number',
            elementMandatory: false,
            elementSequenceNumber: 1,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'cardNumber',
            elementLabel: 'Account Number',
            elementMandatory: false,
            elementSequenceNumber: 2,
            elementTypeName: 'CC_NUMBER',
            cardOption: {
              value: 'six-four-digits',
              text: 'First 6 / Last 4',
            },
            translations: { helperText: '(first 6 or last 4 digits)', first6Placeholder: 'First 6', cardNum: 'Account Number (first 6 or last 4 digits)', last4Placeholder: 'Last 4' },

          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'globalToken',
            elementLabel: 'Account Number',
            elementMandatory: false,
            elementSequenceNumber: 3,
            elementTypeName: 'FULL_CC_NUMBER',
            translations: [],
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'merchantNumber',
            elementLabel: 'Merchant Number',
            elementMandatory: false,
            elementSequenceNumber: 4,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'FROM',
            elementId: 'fromTransactionAmount',
            elementLabel: 'Transaction Amount',
            elementMandatory: false,
            elementSequenceNumber: 6,
            elementTypeName: 'CURRENCYRANGE',
            defaultIsVisible: true,
          },

          {
            elementCategoryName: 'EXACT',
            elementId: 'transactionCode',
            elementLabel: 'Transaction Code',
            elementMandatory: false,
            elementSequenceNumber: 7,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'FROM',
            elementId: 'fromTransactionDate',
            elementLabel: 'Transaction Date Range',
            elementMandatory: true,
            elementSequenceNumber: 4,
            elementTypeName: 'DATE',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'acquirerCode',
            elementLabel: 'Acquirer Name',
            elementMandatory: false,
            elementSequenceNumber: 8,
            elementTypeName: 'MULTISELECT',
            filterValues:  filterValues,
            isMultiSelect :true,
         
          },
        ],
      },
      {
        filterTypeId: 2,
        filterTypeName: 'Authorization',
        apiUrl: 'api/v1/referencedata/authdata',

        filterElements: [
          {
            elementCategoryName: 'EXACT',
            elementId: 'cardNumber',
            elementLabel: 'Account Number',
            elementMandatory: false,
            elementSequenceNumber: 1,
            elementTypeName: 'CC_NUMBER',
            cardOption: {
              value: 'six-four-digits',
              text: 'First 6 / Last 4',
            },
            translations: { helperText: '(first 6 or last 4 digits)', first6Placeholder: 'First 6', cardNum: 'Account Number (first 6 or last 4 digits)', last4Placeholder: 'Last 4' },
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'globalToken',
            elementLabel: 'Account Number',
            elementMandatory: false,
            elementSequenceNumber: 2,
            elementTypeName: 'FULL_CC_NUMBER',
            translations: [],
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'merchantNumber',
            elementLabel: 'Merchant Number',
            elementMandatory: false,
            elementSequenceNumber: 3,
            elementTypeName: 'TEXT',

          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'authorizationCode',
            elementLabel: 'Authorization Code',
            elementMandatory: false,
            elementSequenceNumber: 4,
            elementTypeName: 'TEXT',
          },

          {
            elementCategoryName: 'FROM',
            elementId: 'fromAuthorizationDate',
            elementLabel: 'Authorization Date Range',
            elementMandatory: true,
            elementSequenceNumber: 5,
            elementTypeName: 'DATE',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'acquirerCode',
            elementLabel: 'Acquirer Name',
            elementMandatory: false,
            elementSequenceNumber: 6,
            elementTypeName: 'MULTISELECT',
            filterValues:  filterValues,
            isMultiSelect :true,
         
          },

        ],
      },
      {
        filterTypeId: 3,
        filterTypeName: 'Merchant',
        apiUrl: 'api/v1/referencedata/merchantdetails',
        filterElements: [
          {
            elementCategoryName: 'EXACT',
            elementId: 'merchantNumber',
            elementLabel: 'Merchant Number',
            elementMandatory: false,
            elementSequenceNumber: 1,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'corporate',
            elementLabel: 'Corporate',
            elementMandatory: false,
            elementSequenceNumber: 2,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'region',
            elementLabel: 'Region',
            elementMandatory: false,
            elementSequenceNumber: 3,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'principal',
            elementLabel: 'Principal',
            elementMandatory: false,
            elementSequenceNumber: 4,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'associate',
            elementLabel: 'Associate',
            elementMandatory: false,
            elementSequenceNumber: 5,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'chain',
            elementLabel: 'Chain',
            elementMandatory: false,
            elementSequenceNumber: 7,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'acquirerCode',
            elementLabel: 'Acquirer Name',
            elementMandatory: false,
            elementSequenceNumber: 12,
            elementTypeName: 'MULTISELECT',
            filterValues:  filterValues,
            isMultiSelect :true,
         
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'group',
            elementLabel: 'Group',
            elementMandatory: false,
            elementSequenceNumber: 6,
            elementTypeName: 'TEXT',
            filterValues:  filterValues,
            isMultiSelect :true,
         
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'taxID',
            elementLabel: 'Tax ID',
            elementMandatory: false,
            elementSequenceNumber: 8,
            elementTypeName: 'TEXT',
            filterValues:  filterValues,
            isMultiSelect :true,
         
          },
          // Conditionally add these fields only for GPE (EU portal)
          ...(isGPEAcquirer ? [
            {
              elementCategoryName: 'EXACT',
              elementId: 'company',
              elementLabel: 'Company',
              elementMandatory: false,
              elementSequenceNumber: 9,
              elementTypeName: 'TEXT',
              filterValues:  filterValues,
              isMultiSelect :true,
           
            },
            {
              elementCategoryName: 'EXACT',
              elementId: 'contract',
              elementLabel: 'Contract',
              elementMandatory: false,
              elementSequenceNumber: 10,
              elementTypeName: 'TEXT',
              filterValues:  filterValues,
              isMultiSelect :true,
           
            },
            {
              elementCategoryName: 'EXACT',
              elementId: 'acquirer',
              elementLabel: 'Acquirer',
              elementMandatory: false,
              elementSequenceNumber: 11,
              elementTypeName: 'TEXT',
              filterValues:  filterValues,
              isMultiSelect :true,
           
            }
          ] : []),
        ],
      },
      {
        filterTypeId: 'relatedTransactionSearch',
        filterTypeName: 'Related Transaction',
        apiUrl: 'api/v1/referencedata/related/transactions',
        filterElements: [
          {
            elementCategoryName: 'EXACT',
            elementId: 'acqRefNumber',
            elementLabel: 'Acquirer Reference Number',
            elementMandatory: false,
            elementSequenceNumber: 1,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'cardNumber',
            elementLabel: 'Account Number',
            elementMandatory: false,
            elementSequenceNumber: 2,
            elementTypeName: 'CC_NUMBER',
            cardOption: {
              value: 'six-four-digits',
              text: 'First 6 / Last 4',
            },
            translations: { helperText: '(first 6 or last 4 digits)', first6Placeholder: 'First 6', cardNum: 'Account Number (first 6 or last 4 digits)', last4Placeholder: 'Last 4' },

          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'globalToken',
            elementLabel: 'Account Number',
            elementMandatory: false,
            elementSequenceNumber: 3,
            elementTypeName: 'FULL_CC_NUMBER',
            translations: [],
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'merchantNumber',
            elementLabel: 'Merchant Number',
            elementMandatory: false,
            elementSequenceNumber: 4,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'FROM',
            elementId: 'fromTransactionAmount',
            elementLabel: 'Transaction Amount',
            elementMandatory: false,
            elementSequenceNumber: 6,
            elementTypeName: 'CURRENCYRANGE',
            defaultIsVisible: true,
          },

          {
            elementCategoryName: 'EXACT',
            elementId: 'transactionCode',
            elementLabel: 'Transaction Code',
            elementMandatory: false,
            elementSequenceNumber: 7,
            elementTypeName: 'TEXT',
          },
          {
            elementCategoryName: 'FROM',
            elementId: 'fromTransactionDate',
            elementLabel: 'Transaction Date Range',
            elementMandatory: true,
            elementSequenceNumber: 4,
            elementTypeName: 'DATE',
          },
          {
            elementCategoryName: 'EXACT',
            elementId: 'acquirerCode',
            elementLabel: 'Acquirer Name',
            elementMandatory: false,
            elementSequenceNumber: 8,
            elementTypeName: 'MULTISELECT',
            filterValues:  filterValues,
            isMultiSelect :true,
         
          },
        ],
      },
    ],
  };
}

export function getFilterTranslations() {
  return {
    applyFilterPane: 'Search',
    cancel: 'Cancel',
    clearFilterPane: 'Clear Fields',
    less: 'Less',
    more: 'More',
    select: 'Select',
    apply: 'Apply',
    dates: {
      apply: 'Apply',
      cancel: 'Cancel',
      custom: 'Custom',
      fri: 'Fri',
      from: 'From',
      lastMonth: 'Last Month',
      lastSevenDays: 'Last 7 Days',
      lastThirtyDays: 'Last 30 Days',
      lastWeek: 'Last Week',
      lastYear: 'Select Date(s)',
      mon: 'Mon',
      sat: 'Sat',
      sun: 'Sun',
      thisMonth: 'This Month',
      thisYear: 'This Year',
      thu: 'Thu',
      to: 'To',
      tue: 'Tue',
      unselectedText: 'Select Date(s)',
      validDateError: 'Please enter a valid date.',
      wed: 'Wed',
      yesterday: 'Yesterday',
      jan:'January',
      feb:'February',
      mar:'March',
      apr:'April',
      may:'May',
      jun:'June',
      jul:'July',
      aug:'August',
      sep:'September',
      oct:'October',
      nov:'November',
      dec:'December',
    },
    clear: 'Clear Fields',
    cardNum: 'Account Number (first 6 or last 4 digits)',
    helperText: '(first 6 or last 4 digits)',
    first6Placeholder: counterpart('globalTranslate.queues.firstSix'),
    last4Placeholder: counterpart('globalTranslate.queues.lastFour'),
  };
}
export function getValidations(elementTypeName) {
  return [
    {
      id: 'DATE',
      validations: [
        {
          validationRuleKey: 'DATE_RANGE_VALIDATION',
          validationRef: '',
          translatedErrorMessage: 'Start Date must be before End Date. Check the dates and try again.',
          sequence: 0,
        },
      ],
    },
  ].find((queueMetaData) => {
    return queueMetaData.id === elementTypeName;
  });
}
